import { Injectable } from '@angular/core';
import { ConfirmModalComponent } from '../../confirm-modal/confirm-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

export interface ConfirmModalOptions {
  ok: Function;
  cancel?: Function;
  labels?: string[];
  text: string;
}

const emptyFn = () => {};

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {
  constructor(private modalService: BsModalService) {}

  open(options: ConfirmModalOptions): BsModalRef {
    const modal = this.modalService.show(ConfirmModalComponent, {
      ignoreBackdropClick: true,
      backdrop: true,
      animated: false,
      class: 'confirm-modal',
      keyboard: false,
      initialState: {
        text: options.text,
        ok: options.ok,
        cancel: options.cancel || emptyFn,
        labels: options.labels || ['Ok', 'Cancel']
      }
    });
    const modalContainer = document.querySelector(`.modal-dialog.confirm-modal`).parentElement;
    modalContainer.classList.add('confirm-modal-container');

    return modal;
  }
}
